import React from "react";
import Joi from "joi-browser";
import Form from "../../common/form";
import { GlobalAppContext } from "../../../context";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import InputAdornment from "@material-ui/core/InputAdornment";
// Material UI Icons
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import SubjectIcon from "@material-ui/icons/Subject";
import MessageIcon from "@material-ui/icons/Message";
import PersonIcon from "@material-ui/icons/Person";
import SendIcon from "@material-ui/icons/Send";

import firebase from "../../../services/firebase";

class HomeContactForm extends Form {
  state = {
    data: {
      name: "",
      email: "",
      phoneNumber: "",
      subject: "",
      description: "",
    },
    notification: false,
    subscribe: false,
    errors: {},
  };
  schema = {
    name: Joi.string().required().label("Name"),
    email: Joi.string()
      .required()
      .email({ minDomainSegments: 1, tlds: { allow: ["com", "net"] } })
      .label("Email"),
    phoneNumber: Joi.string().max(10).min(10).required().label("Contact"),
    subject: Joi.string().required().max(25).label("Subject"),
    description: Joi.string().required().max(250).label("Message"),
  };
  doSubmit = async () => {
    firebase.writeToUs(this.state.data);
    console.log("Your messege has been sent.", this.state.data);
    // const { data, profilePic } = this.state;
    // console.log("Submit");
    // if (profilePic) {
    //   await firebase.updateProfileImg(profilePic);
    // }
    // try {
    //   firebase.updataUser(`${data.firstName} ${data.lastName}`);
    this.setState({
      notification: true,
      data: {
        name: "",
        email: "",
        phoneNumber: "",
        subject: "",
        description: "",
      },
    });

    //   setTimeout(() => {
    //     window.location = "/profile";
    //   }, 2000);
    // } catch (error) {
    //   alert("Unknown Problem Detected");
    // }
    // window.location = "/profile";
  };
  render() {
    const { data, errors, subscribe, notification } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="row mb-2">
          <div className="col-md-6 my-2">
            <TextField
              error={errors.name}
              className=""
              id="name"
              label="Name"
              fullWidth
              value={data.name}
              name="name"
              placeholder="Name"
              onChange={this.handleChange}
              variant="standard"
              color="primary"
              helperText={errors.name}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonIcon fontSize="small" className="text-muted" />
                  </InputAdornment>
                ),
              }}
            ></TextField>
          </div>
          <div className="col-md-6 my-2">
            <TextField
              error={errors.phoneNumber}
              className=""
              type="tel"
              id="phoneNumber"
              label="Your Phone"
              fullWidth
              placeholder="9999999999"
              value={data.phoneNumber}
              name="phoneNumber"
              onChange={this.handleChange}
              variant="standard"
              color="primary"
              helperText={errors.phoneNumber}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PhoneIcon fontSize="small" className="text-muted" />
                  </InputAdornment>
                ),
              }}
            ></TextField>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-md-6 my-2">
            <TextField
              error={errors.email}
              className=""
              placeholder="abcd@domain.com"
              id="email"
              label="Email id"
              type="email"
              fullWidth
              name="email"
              value={data.email}
              onChange={this.handleChange}
              variant="standard"
              color="primary"
              helperText={errors.email}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon fontSize="small" className="text-muted" />
                  </InputAdornment>
                ),
              }}
            ></TextField>
          </div>
          <div className="col-md-6 my-2">
            <TextField
              error={errors.subject}
              className=""
              id="subject"
              label="Subject"
              fullWidth
              placeholder="Enquiry"
              value={data.subject}
              name="subject"
              onChange={this.handleChange}
              variant="standard"
              color="primary"
              helperText={errors.subject}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SubjectIcon fontSize="small" className="text-muted" />
                  </InputAdornment>
                ),
              }}
            ></TextField>
          </div>
        </div>
        <div className="row mb-2 position-relative">
          <div className="col-12 my-2 pr-5">
            <TextField
              error={errors.description}
              id="description"
              label="Message"
              fullWidth
              className="pr-5"
              placeholder="Description"
              name="description"
              value={data.description}
              onChange={this.handleChange}
              variant="standard"
              color="primary"
              helperText={errors.description}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MessageIcon fontSize="small" className="text-muted" />
                  </InputAdornment>
                ),
              }}
            ></TextField>
          </div>
          <div className="col my-2">
            <FormControlLabel
              className="mx-0 mb-0"
              control={
                <Checkbox
                  checked={subscribe}
                  onChange={(e) =>
                    this.setState({ subscribe: e.target.checked })
                  }
                  name="Subscribe"
                />
              }
              label="Subscribe Us to get latest update."
            />
          </div>
          <div
            className="bg-dark btn-rounded"
            style={{ position: "absolute", top: 25, right: 12 }}
          >
            <IconButton aria-label="send" type="submit">
              <SendIcon
                style={{
                  fontSize: 40,
                  color: "white",
                  transform: "rotate(-45deg)",
                }}
              />
            </IconButton>
          </div>
        </div>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={notification}
          onClose={() => {
            this.setState({ notification: false });
          }}
          message="Message sent successfully."
          autoHideDuration={2000}
        />
      </form>
    );
  }
}

export default HomeContactForm;
